import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input, output, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { SiaTranslatePipe, notify } from '@sia/shared';
import { MicrosoftAuthService } from '../../services/microsoft-auth-service';
import { MicrosoftLoginService } from '../../services/microsoft-login.service';

@Component({
  selector: 'microsoft-auth-button',
  imports: [SiaTranslatePipe, MatButton, NgTemplateOutlet],
  templateUrl: './microsoft-auth-button.component.html',
  styleUrl: './microsoft-auth-button.component.scss',
})
export class MicrosoftAuthButtonComponent {
  #authService = inject(MicrosoftAuthService);
  #loginService = inject(MicrosoftLoginService);

  /** Flusso Outlook/Graph (default) oppure login portale via Entra ID */
  mode = input<'scope' | 'auth'>('scope');

  /** Variante visiva del bottone Material */
  variant = input<'button' | 'stroked-button'>('button');

  /** Tema del bottone — usare 'dark' su sfondi scuri */
  theme = input<'light' | 'dark'>('light');

  /** Disabilita il bottone dall'esterno */
  disabled = input<boolean>(false);

  // Inputs usati solo in mode='scope'
  scopeType = input<string>('Outlook');
  clientId = input<string>('');
  redirectUri = input<string>(window.location.origin);

  /** Emette il risultato grezzo del backend quando mode='auth' */
  authResult = output<any>();

  loading = signal(false);

  isDisabled = computed(() => this.disabled() || this.loading());

  async loginPopup(): Promise<void> {
    if (this.isDisabled()) return;
    this.loading.set(true);
    try {
      if (this.mode() === 'auth') {
        const result = await this.#loginService.loginPopup();
        this.authResult.emit(result);
      } else {
        await this.#authService.loginPopup(this.scopeType(), this.clientId(), this.redirectUri());
      }
    } catch {
      if (this.mode() === 'auth') {
        notify('Impossibile effettuare login con Microsoft', 2000, 'error');
        this.authResult.emit(null);
      }
    } finally {
      this.loading.set(false);
    }
  }
}
